export const formatCurrency = (value) =>
	new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
		value || 0,
	);

export const formatDate = (date) =>
	date
		? new Date(date).toLocaleDateString("pt-BR", {
				day: "2-digit",
				month: "2-digit",
				year: "numeric",
				hour: "2-digit",
				minute: "2-digit",
			})
		: "-";

export const formatDateShort = (date) =>
	date ? new Date(date).toLocaleDateString("pt-BR") : "-";
